import styled from 'styled-components';

import {
  Avatar as MuiAvatar,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  ListItem as MuiListItem,
  ListItemText as MuiListItemText,
  ListItemTypeMap,
} from '@mui/material';

import { spacing } from '@mui/system';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export const Card = styled(MuiCard)(spacing as any);

export const CardContent = styled(MuiCardContent)(spacing as any);

export const Divider = styled(MuiDivider)(spacing as any);

export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing as any);

export const ListItem = styled(MuiListItem)(spacing as any);

export const ListItemNotButton: OverridableComponent<ListItemTypeMap<{ button?: false }, 'li'>> =
  styled(MuiListItem)(spacing as any);

export const Avatar = styled(MuiAvatar)(spacing as any);

export const ListItemText = styled(MuiListItemText)(spacing as any);
